<template lang="pug">
include RegisterStep1.pug
</template>

<script>
import _ from "underscore"
import Api from "@/components/services/Api"
import { mapState } from 'vuex'

export default {
  name: 'RegisterStep1',
  data() {
    return {
      email: "",
      password2: "",
      password: "",
      error: null,
    }
  },
  computed: _.extend(mapState([
    "context",
  ]), {
    valid: function() {
      if (this.password != this.password2) {
        return false
      }
      if (!this.password || !this.password.length) {
        return false
      }
      if (!this.email || !this.email.length) {
        return false
      }
      return true
    },
  }),
  methods: {
    async save() {
      this.error = null
      const response = await Api.registerAccount(this.email, this.password)
      const data = response.data
      console.log(response.data)
      if (data.token && data.email) {
        // success
        this.$store.commit("set_token", data.token)
        this.$store.commit("set_type", "professional")
        this.$router.push({
            name: "RegisterStep2",
        });
      } else {

        //this.error = "Error en el registro. Rellene todos los campos con información válida<br>"+data.message
        this.error = "Error en el registro. \n"+data.message
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "RegisterStep1";
</style>



// WEBPACK FOOTER //
// src/components/register/RegisterStep1.vue